var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"mt-md-2",attrs:{"block":"","color":"primary"},on:{"click":function($event){return _vm.exportPDF()}}},[_vm._v(" Print PDF ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }